import { type V3UiContextSnapshot } from '@apps/web/components/phoebe_chat/v3_ui_context';

export type V3UiContextRegistrationInput = {
    readonly key: string;
    readonly transcriptIndex: number;
    /** Null marks a newer result that must suppress older, stale context. */
    readonly snapshot: V3UiContextSnapshot | null;
};

export type V3UiContextRegistration = V3UiContextRegistrationInput;

export function uniqueV3UiContextRowIds(
    rowIds: ReadonlyArray<string>,
): ReadonlyArray<string> {
    return [...new Set(rowIds)];
}

function compareRegistrationOrder(
    left: V3UiContextRegistration,
    right: V3UiContextRegistration,
): number {
    return (
        left.transcriptIndex - right.transcriptIndex ||
        left.key.localeCompare(right.key)
    );
}

/**
 * Resolve an ambiguous follow-up to one result card.
 *
 * The latest result in the transcript is the least surprising meaning for
 * words such as “these” and “them” when more than one card is on screen.
 */
export function selectV3UiContextSnapshot(
    registrations: ReadonlyArray<V3UiContextRegistration>,
): V3UiContextSnapshot | null {
    const orderedCandidates = [...registrations].sort(compareRegistrationOrder);
    const selected = orderedCandidates[orderedCandidates.length - 1];
    if (
        selected === undefined ||
        selected.snapshot === null ||
        selected.snapshot.visible_row_ids.length === 0
    ) {
        return null;
    }
    return {
        receipt: { ...selected.snapshot.receipt },
        ...(selected.snapshot.reference === undefined
            ? {}
            : { reference: selected.snapshot.reference }),
        visible_row_ids: [...selected.snapshot.visible_row_ids],
    };
}
